import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function BookmarkIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3.5 5.2c0-1.12 0-1.68.21-2.108.185-.376.48-.682.843-.874C4.966 2 5.506 2 6.586 2h2.828c1.08 0 1.62 0 2.033.218.363.192.658.498.843.874.21.428.21.988.21 2.108V14L8 11.333 3.5 14z" /></svg>
  );
}

export default BookmarkIcon;
